import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "tile-view-carrousel",
  templateUrl: "./tile-view-carrousel.component.html",
  styleUrls: ["./tile-view-carrousel.component.scss"],
})
export class TileViewCarrouselComponent implements OnInit {
  @Input() overallDescriptor;
  @Output() overallDescriptorChange = new EventEmitter();
  rightArrowActive: boolean = false;
  leftArrowActive: boolean = true;
  constructor() {}

  ngOnInit(): void {}

  arrowClicked(type) {
    if (type === "right") {
      this.overallDescriptorChange.emit("changeDescriptor");
      this.rightArrowActive = true;
      this.leftArrowActive = false;
    } else {
      this.overallDescriptorChange.emit("denominatorDescriptor");
      this.rightArrowActive = false;
      this.leftArrowActive = true;
    }
  }

  arrowHovered(type) {
    if (type === "right") {
      this.rightArrowActive = true;
    } else {
      this.leftArrowActive = true;
    }
  }

  arrowUnHovered(type) {
    if (this.overallDescriptor === "changeDescriptor") {
      this.rightArrowActive = true;
      this.leftArrowActive = false;
    } else {
      this.rightArrowActive = false;
      this.leftArrowActive = true;
    }
  }
}
